import { Action, createReducer, on } from '@ngrx/store';
import { PermissionsViewCacheActions } from '../actions';
import { initialState, PermissionsViewCacheState } from '../states/view-cache.states';

export const permissionViewCacheFeatureKey = 'permissionViewCache';

export const viewCacheReducer = createReducer(
  initialState,
  on(PermissionsViewCacheActions.cacheClientSidePermission, (state, action) => ({...state, clientSidePermssion: action.cache})),
  on(PermissionsViewCacheActions.cachePermissionSet, (state, action) => ({...state, permissionSet: action.cache})),
  on(PermissionsViewCacheActions.cachePermissionWizard, (state,action)=> ({...state, permissionWizard: action.cache})),
  on(PermissionsViewCacheActions.cacheUserPermission, (state, action) => ({...state, userPermission: action.cache})),
  on(PermissionsViewCacheActions.cacheTeamPermission, (state, action) => ({...state, teamPermission: action.cache})),
  on(PermissionsViewCacheActions.cacheRolePermission, (state, action) => ({...state, rolePermission: action.cache})),
  on(PermissionsViewCacheActions.cacheFieldConfiguration, (state, action) => ({...state, fieldConfiguration: action.cache})),
  on(PermissionsViewCacheActions.cacheRolePricingSchemeLink, (state, action) => ({...state, rolePricingSchemeLink: action.cache})),
);

export function permissions_view_cache_reducer(state: PermissionsViewCacheState | undefined, action: Action) {
  return viewCacheReducer(state, action);
}


